import { useReducer } from 'react'
import {
  DASHBOARD_MODE,
  PLAN_BOOK_MODE,
  SUB_MODE,
  DASHBOARD_MODE_TEXT,
} from './Dashboard.constants'
import {
  DashBoardState,
  DashboardActionType,
} from './WorkcentreDashboard.types'

const initialDashboardSettings: DashBoardState = {
  mode: DASHBOARD_MODE_TEXT,
  subMode: '',
  title: 'Workcenter dashboard',
}

const reducer = (state: DashBoardState, action: DashboardActionType) => {
  switch (action.type) {
    case DASHBOARD_MODE:
      return {
        subMode: '',
        mode: action.value,
        title: 'Workcenter dashboard',
      }

    case PLAN_BOOK_MODE:
      return {
        subMode: '',
        mode: action.value,
        title: 'Planning book',
      }
    case SUB_MODE:
      return {
        subMode: action.value,
        mode: 'dashboard',
        title: action.value,
      }
  }
  return state
}

export const useDashboardState = () => {
  return useReducer(reducer, initialDashboardSettings)
}
